module.exports = "/img/family_car.50313945.png";